export class LocationService {
  static readonly QUERY_PARAM = 'code';

  public static get Code() {
    return new URLSearchParams(window.location.search).get(this.QUERY_PARAM);
  }

  public static ReplaceHistoryState() {
    const { pathname, search, hash } = window.location;
    const params = new URLSearchParams(search);

    params.delete(this.QUERY_PARAM);

    const hasParams = !!params.toString();

    const url = pathname + (hasParams ? `?${params.toString()}` : '') + hash;

    window.history.replaceState({}, document.title, url);
  }
}
